// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  depositId: __t.u64().primaryKey().name("deposit_id"),
  systemId: __t.string().name("system_id"),
  beltKey: __t.string().name("belt_key"),
  oreKey: __t.string().name("ore_key"),
  remaining: __t.u32(),
  capacity: __t.u32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
